"use client";
import Link from "next/link";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

import { fetchTournaments } from "~entities/tournament/model/queries";
import { HistorySearchBar } from "~features/history-search-bar/client";
import styles from "./archive-page.module.css";

/** id турнира в сервисе истории и ключ подписи в словаре `history.tournaments`. */
const TOURNAMENT_ROWS = [
  [
    { id: 8, labelKey: "worldChampionships" },
    { id: 9, labelKey: "europeanChampionships" },
    { id: 19, labelKey: "russianChampionships" },
  ],
  [
    { id: 11, labelKey: "worldGames" },
    { id: 7, labelKey: "universiade" },
    { id: 13, labelKey: "europeanGames" },
  ],
  [
    { id: 36, labelKey: "worldCompetitions" },
    { id: 37, labelKey: "europeanCompetitions" },
    { id: 20, labelKey: "russianJuniorChampionships" },
  ],
] as const;

const fadeUp = {
  hidden: { opacity: 0, y: 14 },
  visible: { opacity: 1, y: 0 },
};

export function HistoryPage() {
  const t = useTranslations("history");
  // Список турниров статичный, поэтому запрос только прогревает кэш
  // страницы конкретного турнира и не задерживает отрисовку.
  useQuery(fetchTournaments());

  return (
    <div className={styles.page}>
      <div className={styles.aurora} aria-hidden />

      <motion.div
        className={styles.inner}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <header className={styles.hero}>
          {/*<span className={styles.eyebrow}>Архив соревнований</span>*/}
          <h1 className={styles.title}>{t("title")}</h1>
          {/*<p className={styles.lead}>*/}
          {/*  Результаты, составы и видео выступлений — от первенств России*/}
          {/*  до чемпионатов мира.*/}
          {/*</p>*/}

          <div className={styles.search}>
            <HistorySearchBar />
          </div>
        </header>

        <motion.div
          className={styles.buttons}
          initial="hidden"
          animate="visible"
          transition={{ staggerChildren: 0.05 }}
        >
          {TOURNAMENT_ROWS.map((row, rowIndex) => (
            <div className={styles.buttonsRow} key={rowIndex}>
              {row.map(({ id, labelKey }) => (
                <motion.div
                  key={id}
                  className={styles.buttonSlot}
                  variants={fadeUp}
                  transition={{ duration: 0.35 }}
                >
                  <Link href={`/history/${id}`} className={styles.tourButton}>
                    {t(`tournaments.${labelKey}`)}
                  </Link>
                </motion.div>
              ))}
            </div>
          ))}
        </motion.div>

        <Link href="/hall-fame" className={styles.fame}>
          {t("hallOfFameLink")}
        </Link>

        <p className={styles.supportNote}>
          {t("supportNote")}{" "}
          <a
            className={styles.supportLink}
            href="https://vk.ru/write-81458682"
            target="_blank"
            rel="noreferrer"
          >
            VK
          </a>
        </p>
      </motion.div>
    </div>
  );
}
